import '@babel/polyfill';

import Config from './Config';
import Common from './Common';

require('./libs/daijima/trace.js');
require('./libs/daijima/requestanimationframe.js');

import '../scss/common.scss';
import '../scss/top.scss';

//CSS Modulesとして使用する場合
// import * as styles from "../scss/common.scss";

Config.getInstance();
new Common();
